export default __webpack_public_path__ + "11ae9e09c6b2c0288083de6021bc3a63.png";